'use strict';

const LoginController = function($scope, $stateParams, EventUtil, IntercomService, LoginService, RavenService) {

  const vm = this;
  vm.currentView = '';
  vm.redirectLocation = $stateParams.location;

  // Intercom will start in anonymous mode
  IntercomService.shutdown();
  if (!$stateParams.token) {
    IntercomService.boot();
    RavenService.syncUser();
  }

  const onAuthSuccess = (e, data) => {

    // Terminate anonoymous intercom session
    IntercomService.shutdown();

    if (vm.redirectLocation) {
      data.location = vm.redirectLocation;
    }

    LoginService.authSuccess(data);
  };

  const onAuthError = (e, data) => {

    console.error('Login Error:', data);
  };

  EventUtil.on($scope, 'auth:success', onAuthSuccess);
  EventUtil.on($scope, 'auth:error', onAuthError);
};

LoginController.$inject = ['$scope', '$stateParams', 'EventUtil', 'IntercomService', 'LoginService', 'RavenService'];
module.exports = LoginController;



// WEBPACK FOOTER //
// ./src/app/login/LoginController.js